export default () => (
  <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm4.414-11.836-5 5a.934.934 0 0 1-1.324 0l-2.5-2.5a.937.937 0 0 1 1.324-1.324l1.836 1.836 4.336-4.34a.937.937 0 0 1 1.324 1.324l.004.004Z" />
);
